/*
 * @Description: 自定义指令 - 保留选中文字（选中文字后出现保留按钮）
 * @Author: Xiaochun liu
 * @Date: 2023-10-11 10:35:59
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-01-10 17:01:25
 */
import type { DirectiveBinding } from 'vue'
import type { DirectiveDomElement } from '@/utils/dom/dom'

/**
 * @Description 保留选中文字（选中文字后出现保留按钮）
 * @params binding 传入回调函数callback，函数会带选中的文字
 * 问题：点击区域外部的按钮，没有取消选中
 */
const reserveSelectTextDirective = {
  name: 'reserve-select-text', // 指令名称，和组件名称一致
  mounted(el: DirectiveDomElement, binding: DirectiveBinding) {
    if (binding.value.disabled) {
      return
    }
    function removeDirectiveReserveId() {
      // 根据id查找是否有 保留 按钮，如有则移除先
      const directiveReserveId = document.getElementById('directiveReserveId')
      if (directiveReserveId) {
        directiveReserveId.remove()
      }
    }
    el.addEventListener('mouseup', () => {
      removeDirectiveReserveId()

      // 选中的文字
      setTimeout(() => {
        const text = (window.getSelection() as Selection).toString()
        console.log(text, 'text')
        const textType = (window.getSelection() as Selection).type
        console.log(window.getSelection(), textType, 'window.getSelection() ', (window.getSelection() as Selection).isCollapsed)

        if (!text) {
          removeDirectiveReserveId()
          return
        }

        const range = (window.getSelection() as Selection).getRangeAt(0)
        const rect = range.getBoundingClientRect()
        // 创建 保留 按钮
        const reserveBtn = document.createElement('button')
        reserveBtn.innerText = '保留'
        reserveBtn.className = 'directive-reserve-btn'
        reserveBtn.id = 'directiveReserveId'
        reserveBtn.style.top = `${rect.bottom}px`
        reserveBtn.style.left = `${rect.right}px`
        // 按钮点击事件
        reserveBtn.addEventListener('click', () => {
          binding.value.callback && binding.value.callback(text)
          reserveBtn.parentNode?.removeChild(reserveBtn)
        })
        document.body.appendChild(reserveBtn)
      }, 10)
    })
    window.addEventListener('click', () => {
      // const text = (window.getSelection() as Selection).toString()
      // if (!text) {
      removeDirectiveReserveId()
      // }
    })
    // 监听滚轮滚动
    window.addEventListener('wheel', removeDirectiveReserveId)
  },
}

export default reserveSelectTextDirective
